<div style="padding: 0.5em;">
    <h1 mat-dialog-title>EC Complete Confirmation</h1>
    <mat-dialog-content>
        <p style="text-align: justify;">Are you sure to change the EC completed status?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="onConfirm()">Yes</button>
        <button mat-button mat-dialog-close (click)="onCancel()">No</button>
    </mat-dialog-actions>
</div>